var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a, prop, b2[prop]);
    }
  return a;
};
var __spreadProps = (a, b2) => __defProps(a, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React, { forwardRef, useState, useEffect } from "react";
let v = false;
const k = [], w = (o) => new Promise((t, e) => {
  if (typeof window > "u" || (window.storyblokRegisterEvent = (r) => {
    if (window.location === window.parent.location) {
      console.warn("You are not in Draft Mode or in the Visual Editor.");
      return;
    }
    v ? r() : k.push(r);
  }, document.getElementById("storyblok-javascript-bridge")))
    return;
  const s = document.createElement("script");
  s.async = true, s.src = o, s.id = "storyblok-javascript-bridge", s.onerror = (r) => e(r), s.onload = (r) => {
    k.forEach((n) => n()), v = true, t(r);
  }, document.getElementsByTagName("head")[0].appendChild(s);
});
var $ = Object.defineProperty, P = (o, t, e) => t in o ? $(o, t, { enumerable: true, configurable: true, writable: true, value: e }) : o[t] = e, l = (o, t, e) => (P(o, typeof t != "symbol" ? t + "" : t, e), e);
function b(o) {
  return !(o !== o || o === 1 / 0 || o === -1 / 0);
}
function x(o, t, e) {
  if (!b(t))
    throw new TypeError("Expected `limit` to be a finite number");
  if (!b(e))
    throw new TypeError("Expected `interval` to be a finite number");
  const s = [];
  let r = [], n = 0;
  const i = function() {
    n++;
    const c = setTimeout(function() {
      n--, s.length > 0 && i(), r = r.filter(function(u) {
        return u !== c;
      });
    }, e);
    r.indexOf(c) < 0 && r.push(c);
    const h = s.shift();
    h.resolve(o.apply(h.self, h.args));
  }, a = function(...c) {
    const h = this;
    return new Promise(function(u, d) {
      s.push({
        resolve: u,
        reject: d,
        args: c,
        self: h
      }), n < t && i();
    });
  };
  return a.abort = function() {
    r.forEach(clearTimeout), r = [], s.forEach(function(c) {
      c.reject(function() {
        Error.call(this, "Throttled function aborted"), this.name = "AbortError";
      });
    }), s.length = 0;
  }, a;
}
const E = function(o, t) {
  const e = {};
  for (const s in o) {
    const r = o[s];
    t.indexOf(s) > -1 && r !== null && (e[s] = r);
  }
  return e;
}, j = (o) => o === "email", S = () => ({
  singleTag: "hr"
}), O = () => ({
  tag: "blockquote"
}), C = () => ({
  tag: "ul"
}), I = (o) => ({
  tag: [
    "pre",
    {
      tag: "code",
      attrs: o.attrs
    }
  ]
}), A = () => ({
  singleTag: "br"
}), N = (o) => ({
  tag: `h${o.attrs.level}`
}), M = (o) => ({
  singleTag: [
    {
      tag: "img",
      attrs: E(o.attrs, ["src", "alt", "title"])
    }
  ]
}), L = () => ({
  tag: "li"
}), U = () => ({
  tag: "ol"
}), H = () => ({
  tag: "p"
}), B = () => ({
  tag: "b"
}), q = () => ({
  tag: "strike"
}), D = () => ({
  tag: "u"
}), J = () => ({
  tag: "strong"
}), F = () => ({
  tag: "code"
}), V = () => ({
  tag: "i"
}), z = (o) => {
  const t = __spreadValues({}, o.attrs), { linktype: e = "url" } = o.attrs;
  return j(e) && (t.href = `mailto:${t.href}`), t.anchor && (t.href = `${t.href}#${t.anchor}`, delete t.anchor), {
    tag: [
      {
        tag: "a",
        attrs: t
      }
    ]
  };
}, Y = (o) => ({
  tag: [
    {
      tag: "span",
      attrs: o.attrs
    }
  ]
}), K = {
  nodes: {
    horizontal_rule: S,
    blockquote: O,
    bullet_list: C,
    code_block: I,
    hard_break: A,
    heading: N,
    image: M,
    list_item: L,
    ordered_list: U,
    paragraph: H
  },
  marks: {
    bold: B,
    strike: q,
    underline: D,
    strong: J,
    code: F,
    italic: V,
    link: z,
    styled: Y
  }
}, Q = function(o) {
  const t = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  }, e = /[&<>"']/g, s = RegExp(e.source);
  return o && s.test(o) ? o.replace(e, (r) => t[r]) : o;
};
class m {
  constructor(t) {
    l(this, "marks"), l(this, "nodes"), t || (t = K), this.marks = t.marks || [], this.nodes = t.nodes || [];
  }
  addNode(t, e) {
    this.nodes[t] = e;
  }
  addMark(t, e) {
    this.marks[t] = e;
  }
  render(t) {
    if (t && t.content && Array.isArray(t.content)) {
      let e = "";
      return t.content.forEach((s) => {
        e += this.renderNode(s);
      }), e;
    }
    return console.warn("The render method must receive an object with a content field, which is an array"), "";
  }
  renderNode(t) {
    const e = [];
    t.marks && t.marks.forEach((r) => {
      const n = this.getMatchingMark(r);
      n && e.push(this.renderOpeningTag(n.tag));
    });
    const s = this.getMatchingNode(t);
    return s && s.tag && e.push(this.renderOpeningTag(s.tag)), t.content ? t.content.forEach((r) => {
      e.push(this.renderNode(r));
    }) : t.text ? e.push(Q(t.text)) : s && s.singleTag ? e.push(this.renderTag(s.singleTag, " /")) : s && s.html && e.push(s.html), s && s.tag && e.push(this.renderClosingTag(s.tag)), t.marks && t.marks.slice(0).reverse().forEach((r) => {
      const n = this.getMatchingMark(r);
      n && e.push(this.renderClosingTag(n.tag));
    }), e.join("");
  }
  renderTag(t, e) {
    return t.constructor === String ? `<${t}${e}>` : t.map((s) => {
      if (s.constructor === String)
        return `<${s}${e}>`;
      {
        let r = `<${s.tag}`;
        if (s.attrs)
          for (const n in s.attrs) {
            const i = s.attrs[n];
            i !== null && (r += ` ${n}="${i}"`);
          }
        return `${r}${e}>`;
      }
    }).join("");
  }
  renderOpeningTag(t) {
    return this.renderTag(t, "");
  }
  renderClosingTag(t) {
    return t.constructor === String ? `</${t}>` : t.slice(0).reverse().map((e) => e.constructor === String ? `</${e}>` : `</${e.tag}>`).join("");
  }
  getMatchingNode(t) {
    const e = this.nodes[t.type];
    if (typeof e == "function")
      return e(t);
  }
  getMatchingMark(t) {
    const e = this.marks[t.type];
    if (typeof e == "function")
      return e(t);
  }
}
class T {
  constructor() {
    l(this, "isCDNUrl", (t = "") => t.indexOf("/cdn/") > -1), l(this, "getOptionsPage", (t, e = 25, s = 1) => __spreadProps(__spreadValues({}, t), {
      per_page: e,
      page: s
    })), l(this, "delay", (t) => new Promise((e) => setTimeout(e, t))), l(this, "arrayFrom", (t = 0, e) => [...Array(t)].map(e)), l(this, "range", (t = 0, e = t) => {
      const s = Math.abs(e - t) || 0, r = t < e ? 1 : -1;
      return this.arrayFrom(s, (n, i) => i * r + t);
    }), l(this, "asyncMap", async (t, e) => Promise.all(t.map(e))), l(this, "flatMap", (t = [], e) => t.map(e).reduce((s, r) => [...s, ...r], []));
  }
  stringify(t, e, s) {
    const r = [];
    for (const n in t) {
      if (!Object.prototype.hasOwnProperty.call(t, n))
        continue;
      const i = t[n], a = s ? "" : encodeURIComponent(n);
      let c;
      typeof i == "object" ? c = this.stringify(i, e ? e + encodeURIComponent("[" + a + "]") : a, Array.isArray(i)) : c = (e ? e + encodeURIComponent("[" + a + "]") : a) + "=" + encodeURIComponent(i), r.push(c);
    }
    return r.join("&");
  }
}
class G {
  constructor(t) {
    l(this, "baseURL"), l(this, "timeout"), l(this, "headers"), l(this, "responseInterceptor"), l(this, "fetch"), l(this, "ejectInterceptor"), l(this, "url"), l(this, "parameters"), this.baseURL = t.baseURL, this.headers = t.headers || [], this.timeout = t != null && t.timeout ? t.timeout * 1e3 : 0, this.responseInterceptor = t.responseInterceptor, this.fetch = (...e) => t.fetch ? t.fetch(...e) : fetch(...e), this.ejectInterceptor = false, this.url = "", this.parameters = {};
  }
  get(t, e) {
    return this.url = t, this.parameters = e, this._methodHandler("get");
  }
  post(t, e) {
    return this.url = t, this.parameters = e, this._methodHandler("post");
  }
  put(t, e) {
    return this.url = t, this.parameters = e, this._methodHandler("put");
  }
  delete(t, e) {
    return this.url = t, this.parameters = e, this._methodHandler("delete");
  }
  async _responseHandler(t) {
    const e = [], s = {
      data: {},
      headers: {},
      status: 0,
      statusText: ""
    };
    t.status !== 204 && await t.json().then((r) => {
      s.data = r;
    });
    for (const r of t.headers.entries())
      e[r[0]] = r[1];
    return s.headers = __spreadValues({}, e), s.status = t.status, s.statusText = t.statusText, s;
  }
  async _methodHandler(t) {
    let e = `${this.baseURL}${this.url}`, s = null;
    if (t === "get") {
      const c = new T();
      e = `${this.baseURL}${this.url}?${c.stringify(this.parameters)}`;
    } else
      s = JSON.stringify(this.parameters);
    const r = new URL(e), n = new AbortController(), { signal: i } = n;
    let a;
    this.timeout && (a = setTimeout(() => n.abort(), this.timeout));
    try {
      const c = await this.fetch(`${r}`, {
        method: t,
        headers: this.headers,
        body: s,
        signal: i
      });
      this.timeout && clearTimeout(a);
      const h = await this._responseHandler(c);
      return this.responseInterceptor && !this.ejectInterceptor ? this._statusHandler(this.responseInterceptor(h)) : this._statusHandler(h);
    } catch (c) {
      return {
        message: c
      };
    }
  }
  eject() {
    this.ejectInterceptor = true;
  }
  _statusHandler(t) {
    const e = /20[0-6]/g;
    return new Promise((s, r) => {
      if (e.test(`${t.status}`))
        return s(t);
      const n = {
        message: new Error(t.statusText),
        status: t.status,
        response: t.data.error || t.data.slug
      };
      r(n);
    });
  }
}
let f = {};
const p = {};
class W {
  constructor(t, e) {
    if (l(this, "client"), l(this, "maxRetries"), l(this, "throttle"), l(this, "accessToken"), l(this, "cache"), l(this, "helpers"), l(this, "relations"), l(this, "links"), l(this, "richTextResolver"), l(this, "resolveNestedRelations"), !e) {
      const n = t.region ? `-${t.region}` : "", i = t.https === false ? "http" : "https";
      t.oauthToken ? e = `${i}://api${n}.storyblok.com/v1` : e = `${i}://api${n}.storyblok.com/v2`;
    }
    const s = new Headers();
    s.set("Content-Type", "application/json"), s.set("Accept", "application/json"), s.forEach((n, i) => {
      t.headers && t.headers[i] && s.set(i, t.headers[i]);
    });
    let r = 5;
    t.oauthToken && (s.set("Authorization", t.oauthToken), r = 3), t.rateLimit && (r = t.rateLimit), t.richTextSchema ? this.richTextResolver = new m(t.richTextSchema) : this.richTextResolver = new m(), t.componentResolver && this.setComponentResolver(t.componentResolver), this.maxRetries = t.maxRetries, this.throttle = x(this.throttledRequest, r, 1e3), this.accessToken = t.accessToken || "", this.relations = {}, this.links = {}, this.cache = t.cache || { clear: "manual" }, this.helpers = new T(), this.resolveNestedRelations = false, this.client = new G({
      baseURL: e,
      timeout: t.timeout || 0,
      headers: s,
      responseInterceptor: t.responseInterceptor,
      fetch: t.fetch
    });
  }
  setComponentResolver(t) {
    this.richTextResolver.addNode("blok", (e) => {
      let s = "";
      return e.attrs.body.forEach((r) => {
        s += t(r.component, r);
      }), {
        html: s
      };
    });
  }
  parseParams(t) {
    return t.version || (t.version = "published"), t.token || (t.token = this.getToken()), t.cv || (t.cv = p[t.token]), Array.isArray(t.resolve_relations) && (t.resolve_relations = t.resolve_relations.join(",")), t;
  }
  factoryParamOptions(t, e) {
    return this.helpers.isCDNUrl(t) ? this.parseParams(e) : e;
  }
  makeRequest(t, e, s, r) {
    const n = this.factoryParamOptions(t, this.helpers.getOptionsPage(e, s, r));
    return this.cacheResponse(t, n);
  }
  get(t, e) {
    e || (e = {});
    const s = `/${t}`, r = this.factoryParamOptions(s, e);
    return this.cacheResponse(s, r);
  }
  async getAll(t, e, s) {
    const r = (e == null ? void 0 : e.per_page) || 25, n = `/${t}`, i = n.split("/"), a = s || i[i.length - 1], c = 1, h = await this.makeRequest(n, e, r, c), u = h.total ? Math.ceil(h.total / r) : 1, d = await this.helpers.asyncMap(this.helpers.range(c, u), (g) => this.makeRequest(n, e, r, g + 1));
    return this.helpers.flatMap([h, ...d], (g) => Object.values(g.data[a]));
  }
  post(t, e) {
    const s = `/${t}`;
    return Promise.resolve(this.throttle("post", s, e));
  }
  put(t, e) {
    const s = `/${t}`;
    return Promise.resolve(this.throttle("put", s, e));
  }
  delete(t, e) {
    const s = `/${t}`;
    return Promise.resolve(this.throttle("delete", s, e));
  }
  getStories(t) {
    return this.get("cdn/stories", t);
  }
  getStory(t, e) {
    return this.get(`cdn/stories/${t}`, e);
  }
  getToken() {
    return this.accessToken;
  }
  ejectInterceptor() {
    this.client.eject();
  }
  _cleanCopy(t) {
    return JSON.parse(JSON.stringify(t));
  }
  _insertLinks(t, e) {
    const s = t[e];
    s && s.fieldtype == "multilink" && s.linktype == "story" && typeof s.id == "string" && this.links[s.id] ? s.story = this._cleanCopy(this.links[s.id]) : s && s.linktype === "story" && typeof s.uuid == "string" && this.links[s.uuid] && (s.story = this._cleanCopy(this.links[s.uuid]));
  }
  _insertRelations(t, e, s) {
    if (s.indexOf(`${t.component}.${e}`) > -1) {
      if (typeof t[e] == "string")
        this.relations[t[e]] && (t[e] = this._cleanCopy(this.relations[t[e]]));
      else if (t[e] && t[e].constructor === Array) {
        const r = [];
        t[e].forEach((n) => {
          this.relations[n] && r.push(this._cleanCopy(this.relations[n]));
        }), t[e] = r;
      }
    }
  }
  iterateTree(t, e) {
    const s = (r) => {
      if (r != null) {
        if (r.constructor === Array)
          for (let n = 0; n < r.length; n++)
            s(r[n]);
        else if (r.constructor === Object) {
          if (r._stopResolving)
            return;
          for (const n in r)
            (r.component && r._uid || r.type === "link") && (this._insertRelations(r, n, e), this._insertLinks(r, n)), s(r[n]);
        }
      }
    };
    s(t.content);
  }
  async resolveLinks(t, e) {
    let s = [];
    if (t.link_uuids) {
      const r = t.link_uuids.length, n = [], i = 50;
      for (let a = 0; a < r; a += i) {
        const c = Math.min(r, a + i);
        n.push(t.link_uuids.slice(a, c));
      }
      for (let a = 0; a < n.length; a++)
        (await this.getStories({
          per_page: i,
          language: e.language,
          version: e.version,
          by_uuids: n[a].join(",")
        })).data.stories.forEach((c) => {
          s.push(c);
        });
    } else
      s = t.links;
    s.forEach((r) => {
      this.links[r.uuid] = __spreadProps(__spreadValues({}, r), { _stopResolving: true });
    });
  }
  async resolveRelations(t, e) {
    let s = [];
    if (t.rel_uuids) {
      const r = t.rel_uuids.length, n = [], i = 50;
      for (let a = 0; a < r; a += i) {
        const c = Math.min(r, a + i);
        n.push(t.rel_uuids.slice(a, c));
      }
      for (let a = 0; a < n.length; a++)
        (await this.getStories({
          per_page: i,
          language: e.language,
          version: e.version,
          by_uuids: n[a].join(",")
        })).data.stories.forEach((c) => {
          s.push(c);
        });
    } else
      s = t.rels;
    s && s.length > 0 && s.forEach((r) => {
      this.relations[r.uuid] = __spreadProps(__spreadValues({}, r), { _stopResolving: true });
    });
  }
  async resolveStories(t, e) {
    var s, r;
    let n = [];
    if (typeof e.resolve_relations < "u" && e.resolve_relations.length > 0 && (typeof e.resolve_relations == "string" && (n = e.resolve_relations.split(",")), await this.resolveRelations(t, e)), e.resolve_links && ["1", "story", "url"].indexOf(e.resolve_links) > -1 && ((s = t.links) != null && s.length || (r = t.link_uuids) != null && r.length) && await this.resolveLinks(t, e), this.resolveNestedRelations)
      for (const i in this.relations)
        this.iterateTree(this.relations[i], n);
    t.story ? this.iterateTree(t.story, n) : t.stories.forEach((i) => {
      this.iterateTree(i, n);
    });
  }
  async cacheResponse(t, e, s) {
    const r = this.helpers.stringify({ url: t, params: e }), n = this.cacheProvider();
    if (this.cache.clear === "auto" && e.version === "draft" && await this.flushCache(), e.version === "published" && t != "/cdn/spaces/me") {
      const i = await n.get(r);
      if (i)
        return Promise.resolve(i);
    }
    return new Promise((i, a) => {
      try {
        (async () => {
          var c;
          try {
            const h = await this.throttle("get", t, e);
            let u = { data: h.data, headers: h.headers };
            return (c = h.headers) != null && c["per-page"] && (u = Object.assign({}, u, {
              perPage: h.headers["per-page"] ? parseInt(h.headers["per-page"]) : 0,
              total: h.headers["per-page"] ? parseInt(h.headers.total) : 0
            })), h.status != 200 ? a(h) : ((u.data.story || u.data.stories) && await this.resolveStories(u.data, e), e.version === "published" && t != "/cdn/spaces/me" && await n.set(r, u), u.data.cv && e.token && (e.version == "draft" && p[e.token] != u.data.cv && await this.flushCache(), p[e.token] = u.data.cv), i(u));
          } catch (h) {
            return a(h);
          }
        })();
      } catch {
      }
    });
  }
  throttledRequest(t, e, s) {
    return this.client[t](e, s);
  }
  cacheVersions() {
    return p;
  }
  cacheVersion() {
    return p[this.accessToken];
  }
  setCacheVersion(t) {
    this.accessToken && (p[this.accessToken] = t);
  }
  cacheProvider() {
    switch (this.cache.type) {
      case "memory":
        return {
          get(t) {
            return Promise.resolve(f[t]);
          },
          getAll() {
            return Promise.resolve(f);
          },
          set(t, e) {
            return f[t] = e, Promise.resolve(void 0);
          },
          flush() {
            return f = {}, Promise.resolve(void 0);
          }
        };
      case "custom":
        if (this.cache.custom)
          return this.cache.custom;
      default:
        return {
          get() {
            return Promise.resolve(void 0);
          },
          getAll() {
            return Promise.resolve(void 0);
          },
          set() {
            return Promise.resolve(void 0);
          },
          flush() {
            return Promise.resolve(void 0);
          }
        };
    }
  }
  async flushCache() {
    return await this.cacheProvider().flush(), this;
  }
}
const X = (o = {}) => {
  const { apiOptions: t } = o;
  if (!t.accessToken) {
    console.error("You need to provide an access token to interact with Storyblok API. Read https://www.storyblok.com/docs/api/content-delivery#topics/authentication");
    return;
  }
  return { storyblokApi: new W(t) };
}, Z = (o) => {
  if (typeof o != "object" || typeof o._editable > "u")
    return {};
  const t = JSON.parse(o._editable.replace(/^<!--#storyblok#/, "").replace(/-->$/, ""));
  return {
    "data-blok-c": JSON.stringify(t),
    "data-blok-uid": t.id + "-" + t.uid
  };
};
let y;
const _ = "https://app.storyblok.com/f/storyblok-v2-latest.js", tt = (o, t, e = {}) => {
  if (!(typeof window > "u") && typeof window.storyblokRegisterEvent < "u") {
    if (!o) {
      console.warn("Story ID is not defined. Please provide a valid ID.");
      return;
    }
    window.storyblokRegisterEvent(() => {
      new window.StoryblokBridge(e).on(["input", "published", "change"], (i) => {
        i.action === "input" && i.story.id === o ? t(i.story) : (i.action === "change" || i.action === "published") && i.storyId === o && window.location.reload();
      });
    });
  }
}, et = (o = {}) => {
  var u, d;
  const {
    bridge: t,
    accessToken: e,
    use: s = [],
    apiOptions: r = {},
    richText: n = {}
  } = o;
  r.accessToken = r.accessToken || e;
  const i = { bridge: t, apiOptions: r };
  let a = {};
  s.forEach((g) => {
    a = __spreadValues(__spreadValues({}, a), g(i));
  });
  const h = !(typeof window > "u") && ((d = (u = window.location) == null ? void 0 : u.search) == null ? void 0 : d.includes("_storyblok_tk"));
  return t !== false && h && w(_), y = new m(n.schema), n.resolver && R(y, n.resolver), a;
}, R = (o, t) => {
  o.addNode("blok", (e) => {
    let s = "";
    return e.attrs.body.forEach((r) => {
      s += t(r.component, r);
    }), {
      html: s
    };
  });
}, st = (o, t, e) => {
  let s = e || y;
  if (!s) {
    console.error("Please initialize the Storyblok SDK before calling the renderRichText function");
    return;
  }
  return o === "" ? "" : o ? (t && (s = new m(t.schema), t.resolver && R(s, t.resolver)), s.render(o)) : (console.warn(`${o} is not a valid Richtext object. This might be because the value of the richtext field is empty.
    
  For more info about the richtext object check https://github.com/storyblok/storyblok-js#rendering-rich-text`), "");
};
const StoryblokComponent = forwardRef((_a, ref) => {
  var _b = _a, { blok } = _b, restProps = __objRest(_b, ["blok"]);
  if (!blok) {
    console.error("Please provide a 'blok' property to the StoryblokComponent");
    return /* @__PURE__ */ React.createElement("div", null, "Please provide a blok property to the StoryblokComponent");
  }
  const Component = getComponent(blok.component);
  if (Component) {
    return /* @__PURE__ */ React.createElement(Component, __spreadValues({
      ref,
      blok
    }, restProps));
  }
  return /* @__PURE__ */ React.createElement("div", null);
});
StoryblokComponent.displayName = "StoryblokComponent";
const useStoryblok = (slug, apiOptions = {}, bridgeOptions = {}) => {
  let [story, setStory] = useState({});
  if (!storyblokApiInstance) {
    console.error("You can't use useStoryblok if you're not loading apiPlugin.");
    return null;
  }
  const isBridgeEnable = typeof window !== "undefined" && typeof window.storyblokRegisterEvent !== "undefined";
  useEffect(() => {
    async function initStory() {
      const { data } = await storyblokApiInstance.get(`cdn/stories/${slug}`, apiOptions);
      setStory(data.story);
      if (isBridgeEnable && data.story.id) {
        tt(data.story.id, (story2) => setStory(story2), bridgeOptions);
      }
    }
    initStory();
  }, [slug]);
  return story;
};
const useStoryblokState = (initialStory = null, bridgeOptions = {}) => {
  let [story, setStory] = useState(initialStory);
  const isBridgeEnable = typeof window !== "undefined" && typeof window.storyblokRegisterEvent !== "undefined";
  if (!isBridgeEnable || !initialStory) {
    return initialStory;
  }
  useEffect(() => {
    setStory(initialStory);
    tt(story.id, (newStory) => setStory(newStory), bridgeOptions);
  }, [initialStory]);
  return story;
};
let storyblokApiInstance = null;
const useStoryblokApi = () => {
  if (!storyblokApiInstance) {
    console.error("You can't use getStoryblokApi if you're not loading apiPlugin.");
  }
  return storyblokApiInstance;
};
let componentsMap = {};
const getComponent = (componentKey) => {
  if (!componentsMap[componentKey]) {
    console.error(`Component ${componentKey} doesn't exist.`);
    return false;
  }
  return componentsMap[componentKey];
};
const storyblokInit = (pluginOptions = {}) => {
  const { storyblokApi } = et(pluginOptions);
  storyblokApiInstance = storyblokApi;
  componentsMap = pluginOptions.components;
};
export { m as RichTextResolver, K as RichTextSchema, StoryblokComponent, X as apiPlugin, getComponent, useStoryblokApi as getStoryblokApi, tt as registerStoryblokBridge, st as renderRichText, Z as storyblokEditable, storyblokInit, useStoryblok, useStoryblokApi, tt as useStoryblokBridge, useStoryblokState };
